export default "__VITE_ASSET__B7Lv94AE__"